export const ROUTE_CONSTANTS = {
  HOME: "/",
  CUSTOMERS: "/customers",
  USERS: "/users",
  LOGIN: "/login",
  DASHBOARD: "/",
  PROFILE: "/profile",
  SETTINGS: "/settings",
  PRIVACY_POLICY: "/privacy-policy",
  TOKEN: "/token",
  NOT_FOUND: "*",
} as const;
